import { NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

@Component({
  selector: 'ui-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  standalone: true,
  imports: [NgStyle, NzTypographyModule],
})
export class UIText {
  @Input() text? = '';
  @Input() fontSize?: string; //in px
  @Input() ellipsisRows?: number = 1; //in px
  @Input() showTooltip = false;
}
